<template>
	<ul class="sidebar-dropdown my-2 flex flex-col gap-2 pl-3 lg:pl-10 cursor-pointer">
		<template v-for="(childItem, index) in items" :key="index">
			<li v-if="(childItem.permission === null || childItem.permission === true) && !childItem.hidden && canViewMenu(childItem.route.name)">
				<div
					@click="handleItemClick(childItem)"
					class="group relative flex items-center rounded px-4 py-1 font-medium text-label-on-color text-xs lg:text-sm duration-300 ease-in-out hover:bg-primary-darker"
					:class="{ 'bg-primary-darker': router.currentRoute.value.name === childItem.route.name }"
				>
					{{ childItem.label }}
				</div>
				<SidebarDropdown v-if="hasVisibleChildren(childItem)" :items="childItem.children" />
			</li>
		</template>
	</ul>
</template>

<script setup lang="js">
import { ref } from 'vue'
import router from '@/router/router.js'
import { Tenants } from '@/models/tenants/Tenants.js'

const props = defineProps({
	items: { type: Array, default: () => [] }
})

const items = ref(props.items)

const handleItemClick = (item) =>
{
	if (item.route)
	{
		router.push(item.route)
	}
}

/**
 * Checks if any of the children are visible to prevent showing a blank space if none are
 * @param p_item
 * @returns {boolean}
 */
function hasVisibleChildren(p_item)
{
	if (!p_item || !p_item.children || p_item.children.length === 0) return false
	for (let i = 0; i < p_item.children.length; i++)
	{
		if (!p_item.children[i].hidden)
		{
			return true;
		}
	}
	return false;
}

/**
 * Checks if a menu item is disabled for a tenant.
 * @param {string} p_route_name Route name
 * @returns {boolean} True if route is not disabled for tenant
 */
function canViewMenu(p_route_name)
{
	return Tenants.isModuleEnabled(p_route_name)
}
</script>
